import React from "react"
import { Icon } from "@xingternal/winery-ui/lib/Icon"
import styled from "styled-components"
import { RECRUITER_INSIGHTS_COLOR } from "../../constants"

const ProductIcon = styled(Icon).attrs({
  color: "white",
})`
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 45%;
  height: 45%;
`

const Wrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  line-height: 0;
`

const Hexagon = () => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill={RECRUITER_INSIGHTS_COLOR}
  >
    <path d="m28.1334211 25.4024808-10.2666776 6.0842465c-1.1550465.6843636-2.5781112.6843636-3.733487 0l-10.26667764-6.0842465c-1.1550465-.6843636-1.86657886-1.9493381-1.86657886-3.3184033v-12.16815496c0-1.36906528.71153236-2.6340397 1.86657886-3.31840336l10.26667764-6.08424643c1.1553758-.68436367 2.5784405-.68436367 3.733487 0l10.2666776 6.08424643c1.1550465.68436366 1.8665789 1.94933808 1.8665789 3.31840336v12.16815496c0 1.3690652-.7115324 2.6340397-1.8665789 3.3184033" />
  </svg>
)

export const RecruiterInsightsLicenseIcon = () => (
  <Wrapper data-testid="license-ri">
    <Hexagon />
    <ProductIcon name="Insights" />
  </Wrapper>
)
